import { render, staticRenderFns } from "./diagnosis.vue?vue&type=template&id=2d035b5c&scoped=true"
import script from "./diagnosis.vue?vue&type=script&lang=js"
export * from "./diagnosis.vue?vue&type=script&lang=js"
import style0 from "./diagnosis.vue?vue&type=style&index=0&id=2d035b5c&prod&lang=less&scoped=true"
import style1 from "./diagnosis.vue?vue&type=style&index=1&id=2d035b5c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d035b5c",
  null
  
)

export default component.exports